/** Status/signal style configs — shared across evaluation category cards, prescreen signals, badges */
export const STATUS_CONFIG = {
    strong: {
        label: 'Strong',
        color: 'text-emerald-400',
        dot: 'bg-emerald-400',
        bg: 'bg-emerald-400/10',
        border: 'border-emerald-400/20',
        filled: 'bg-emerald-500/90 text-white border-emerald-500/90',
    },
    moderate: {
        label: 'Moderate',
        color: 'text-amber-400',
        dot: 'bg-amber-400',
        bg: 'bg-amber-400/10',
        border: 'border-amber-400/20',
        filled: 'bg-amber-500/90 text-white border-amber-500/90',
    },
    weak: {
        label: 'Needs work',
        color: 'text-red-400',
        dot: 'bg-red-400',
        bg: 'bg-red-400/10',
        border: 'border-red-400/20',
        filled: 'bg-red-500/90 text-white border-red-500/90',
    },
};
export function signalStyles(signal) {
    return `${STATUS_CONFIG[signal].bg} ${STATUS_CONFIG[signal].color} ${STATUS_CONFIG[signal].border}`;
}
//# sourceMappingURL=status.js.map